import { render, staticRenderFns } from "./Haikumarine.vue?vue&type=template&id=2fcaa11e"
import script from "./Haikumarine.vue?vue&type=script&lang=js"
export * from "./Haikumarine.vue?vue&type=script&lang=js"
import style0 from "./Haikumarine.vue?vue&type=style&index=0&id=2fcaa11e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports